import { AssignedGoal } from "../../../../cuba/entities/base/tsadv$AssignedGoal";

export const calcTotalWeight = (data: AssignedGoal[]) => {
  const totalWeight =
    data?.reduce((sum, goal) => sum + (goal?.weight || 0), 0) || 0;

  return Math.round(totalWeight * 10) / 10;
};

export const calcTotalResult = (
  data: AssignedGoal[],
  stage: string,
  isUserManager: boolean,
) => {
  const isSecondStep = stage === "COMPLETED";

  const result =
    data?.reduce((sum, goal) => {
      // Если у цели не задан вес, считаем его равным 0
      const weight = goal.weight || 0;
      // Выбираем оценку:
      // - если указана managerAssessment и пользователь — менеджер или это не второй этап — используем её
      // - иначе — используем обычную assessment
      // Если обе оценки не заданы — подставляем 0
      const isResult = !!goal.result;
      const assessment = isResult
        ? goal.result
        : goal.managerAssessment !== undefined &&
            (isUserManager || !isSecondStep)
          ? goal.managerAssessment
          : goal.assessment || 0;
      return sum + (weight * assessment) / 100;
    }, 0) || 0;

  return result;
};
